var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 10C0 4.47716 4.47715 0 10 0H109C114.523 0 119 4.47715 119 10V114H0V10Z",
  fill: "#FF6379",
  fillOpacity: 0.1
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M59 89C76.6731 89 91 74.6731 91 57C91 39.3269 76.6731 25 59 25C41.3269 25 27 39.3269 27 57C27 74.6731 41.3269 89 59 89Z",
  fill: "#FF6379"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M48.3079 73.5689L63.4324 88.6934C77.4005 86.7576 88.4871 75.8082 90.626 61.9061L70.2102 41.4902L48.3079 73.5689Z",
  fill: "#FF415B"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M74.3318 51.4776C74.3318 43.4831 67.7091 37.0353 59.6505 37.3217C51.9745 37.5944 46.0017 44.1362 46.0017 51.8171V67.6702C46.0017 72.1344 49.4325 75.9757 53.8918 76.1856C58.6528 76.4097 62.5832 72.6158 62.5832 67.9042C62.5832 67.8958 62.5832 67.8874 62.5832 67.8791C62.5792 66.5447 63.3781 65.3398 64.6442 64.9183C70.273 63.0444 74.3318 57.7358 74.3318 51.4776Z",
  fill: "#FFCCBD"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2207 37.3145V73.6977C61.6815 72.2031 62.5833 70.1598 62.5833 67.9047C62.5833 67.8963 62.5833 67.888 62.5833 67.8796C62.5793 66.5452 63.3782 65.3403 64.6443 64.9188C70.2731 63.0451 74.332 57.7365 74.332 51.4781C74.3318 43.6731 68.019 37.3436 60.2207 37.3145Z",
  fill: "#FFBDA9"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M51.4311 61.2762H48.7053V52.0789C48.7053 45.7292 53.8711 40.5635 60.2207 40.5635C66.5703 40.5635 71.7362 45.7292 71.7362 52.0789H69.0104C69.0104 47.2322 65.0673 43.2892 60.2207 43.2892C55.3741 43.2892 51.4311 47.2322 51.4311 52.0789V61.2762Z",
  fill: "#F9A58D"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M53.593 69.1068V66.3811C55.2522 66.3811 56.6018 65.0314 56.6018 63.3723C56.6018 61.7132 55.2522 60.3634 53.593 60.3634C52.7767 60.3634 52.0127 60.6851 51.4417 61.2688L49.4929 59.3631C50.5809 58.2504 52.0372 57.6377 53.593 57.6377C56.755 57.6377 59.3275 60.2103 59.3275 63.3723C59.3275 66.5343 56.755 69.1068 53.593 69.1068Z",
  fill: "#F9A58D"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M60.2207 40.5635V43.2892C65.0673 43.2892 69.0105 47.2322 69.0105 52.0789H71.7362C71.7361 45.7292 66.5702 40.5635 60.2207 40.5635Z",
  fill: "#D37F6C"
});
function SvgSymptomEarPain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 114,
    viewBox: "0 0 119 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymptomEarPain);
export default __webpack_public_path__ + "static/media/symptom-Ear-Pain.92e4478d36fe8624fda57db8a9a26492.svg";
export { ForwardRef as ReactComponent };